import state from "./state";

export default {
  SET_LIVECHATADDRESS: (state, val) => {
    state.liveChatAddress = val;
  },
  SET_LIVECHATADDRESSOCSS: (state, val) => {
    state.liveChatAddressOCSS = val;
  },
  SET_LIVECHATOCSSMODE: (state, val) => {
    state.liveChatOCSSMode = val;
  },
  SET_TOKEN: (state, val) => {
    state.token = val;
  },
  SET_U2TOKEN: (state, val) => {
    state.u2token = val;
  },
  SET_INDEX: (state, val) => {
    state.activeIndex = val;
  },
  test: (state, val) => {
    state.test = val;
  },
  SET_BIG_IMAGES: (state, val) => {
    state.bigImagesOne = val;
  },
  SET_SMALL_IMAGES: (state, val) => {
    state.smallImages = val;
  },
  SET_SHOW_DETAIL: (state, val) => {
    state.showDetail = val;
  },
};
